import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import COLORS from '@styles/theme/colors';

export const StyledLink = styled(Link)(({ theme }) => ({
  display: 'block',
  textDecoration: 'none',
  width: '100%',
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.primary,

  '&.active': {
    backgroundColor: COLORS.accent,
    color: 'white'
  },

  '& .MuiTypography-root': {
    fontSize: 16
  }
}));

export const BackLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 40,
  height: 40,
  color: 'white',
  flex: '0 0 auto',
  borderRadius: '50%',
  marginRight: theme.spacing(1),
  transition: 'all .3s ease',

  '&:hover': {
    backgroundColor: 'rgba(255,255,255, .2)'
  }
}));
